/**
 * Detects the payment provider based on customer ID and card type
 * @param {Object} params - Detection parameters
 * @param {string|number} params.customerId - Customer ID from user profile
 * @param {string} params.cardType - Card type from user profile (e.g., 'UPI' for PayPro)
 * @returns {string} Payment provider: 'PAYPRO', 'PADDLE_BILLING', or 'STRIPE'
 */
export const getPaymentProvider = ({ customerId, cardType }) => {
  // Check PayPro first (UPI card type)
  if (cardType === 'UPI') {
    return 'PAYPRO'
  }

  // Convert customerId to string for comparison
  const customerIdStr = String(customerId || '')

  // Check Paddle Billing (ctm_ prefix)
  if (customerIdStr.startsWith('ctm_')) {
    return 'PADDLE_BILLING'
  }

  // Check Stripe (cus_ prefix)
  if (customerIdStr.startsWith('cus_')) {
    return 'STRIPE'
  }

  // Default to STRIPE for any remaining cases
  return 'STRIPE'
}

const PROVIDER_LABELS = {
  STRIPE: 'Stripe',
  PADDLE_BILLING: 'Paddle',
  PAYPRO: 'PayPro'
}

export const getProviderLabel = (profile) => {
  const provider =
    profile?.provider || getPaymentProvider({ customerId: profile?.customerId, cardType: profile?.cardType })
  return PROVIDER_LABELS[provider] || 'Stripe'
}
